module.exports = __webpack_public_path__ + "img/tx3.fcbe78d6.png";